export default __webpack_public_path__ + "705d949958349048cc20191ad1ae2929.png";